// Put your main actions here
import axios from "axios";
import router from "../router/index";

export default {
  updateProcessMarkedRows: ({ commit }, payload) => {
    commit("updateMarkedRows", payload);
  },
  increment: ({ commit }) => {
    commit("increment");
  },
  expireSession: ({ commit, dispatch, state }) => {
    if (!state.user.ACTIVO) {
      setTimeout(() => {
        dispatch("logout");
      }, 20);
    }
  },
  login: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      axios
        .post("/menu_app/authenticate/", payload)
        .then((response) => {
          const payload = {
            token: response.data.token,
            id_client: response.data.id_client,
            id_user: response.data.id_user,
            image: response.data.image,
            usuario: self.usuario,
            menu_user: response.data.menu,
            is_active: response.data.is_active,
            client_details: response.data.client_details
          };
          localStorage.setItem("token", payload.token);
          localStorage.setItem("img", "img/logos/" + payload.image);
          localStorage.setItem("menu", JSON.stringify(payload.menu_user));
          axios.defaults.headers.common["Authorization"] =
            "token " + payload.token;
          commit("auth_success", payload);
          resolve(response);
        })
        .catch(function (error) {
          commit("auth_error");
          localStorage.removeItem("token");
          localStorage.removeItem("img");
          reject(error);
        });
    });
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("img");
      localStorage.removeItem("menu");
      delete axios.defaults.headers.common["Authorization"];
      router.push("/pages/login");
      resolve();
    });
  },

  getCustomers: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get("/production/get_customers/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];
          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }
          customers.unshift({ text: "Seleccione...", value: "" });
          payload = customers;
          commit("getCustomers", payload);
          resolve(res);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
};
